import "media-chrome";
import "vimeo-video-element";
import "youtube-video-element";

import { Menu } from "./components/Menu.js";
import { Sliders } from "./components/Sliders.js";
import { Polaroids } from "./components/Polaroids.js";
import { Carousels } from "./components/Carousels.js";
import { Guides } from "./components/Guides.js";
import { Search } from "./components/Search.js";
import { Accordions } from "./components/Accordions.js";
import { SearchFilters } from "./components/SearchFilters.js";
import { JobsFilter } from "./components/JobsFilter.js";
import { BenefitTooltips } from "./components/BenefitTooltips.js";
import { VideoAnalytics } from "./components/VideoAnalytics.js";

// Initialize all components
new Menu();
new Sliders();
new Polaroids();
new Carousels();
new Guides();
new Search();
new Accordions();
new SearchFilters();
new JobsFilter();
new BenefitTooltips();
new VideoAnalytics();
